import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Svg from "../../../../../Components/Svg/Svg";
import SvgOptions from "../../../../../Components/Svg/SvgOptions";
import css from "./AddQuestion.module.css";
import AddQuestionForm from "./Form";
import QuestionsAside from "./QuestionsAside";
import QuestionModal from "./QuestionModal";
import Button from "../../../../../Components/Button/Button";
import { Get, Post, Put, Delete } from "../../../../../Services/Server";
import Url from "../../../../../Services/Url";
import { toast } from "react-toastify";

const AddQuestion = () => {
	const navigate = useNavigate();
	const [questions, setQuestions] = useState([]);
	const [questionTypes, setQuestionTypes] = useState([]);

	const [newQuestion, setNewQuestion] = useState({
		type: "DROPDOWN",
		text: "",
		options: [{ optionText: "", score: 0, flaggedHighRisk: false }],
	});

	const [modalOpen, setModalOpen] = useState(false);
	const [modalMode, setModalMode] = useState(null);
	const [selectedQuestion, setSelectedQuestion] = useState(null);

	// Fetch Question Types
	useEffect(() => {
		Get(Url.riskTemplate.getQuestionTypes)
			.then(setQuestionTypes)
			.catch((err) => console.error("Failed to load question types", err));
	}, []);

	// Fetch All Questions
	useEffect(() => {
		Get(Url.riskTemplate.getAllQuestions)
			.then(setQuestions)
			.catch((err) => toast.error("Failed to fetch questions", err));
	}, []);

	//  Create Question
	const createQuestion = async (question) => {
		const payload = {
			questionText: question.questionText,
			questionType: question.type.toUpperCase(),
			options: question.options.map((o) => ({
				optionText: o.optionText,
				score: o.score,
				flaggedHighRisk: o.flaggedHighRisk,
			})),
		};

		try {
			const saved = await Post(Url.riskTemplate.createQuestion, payload);
			setQuestions((prev) => [...prev, saved]);
            toast("Risk question saved")
			setNewQuestion({
				type: "DROPDOWN",
				text: "",
				options: [{ optionText: "", score: 0, flaggedHighRisk: false }],
			});
		} catch (err) {
			console.error(err);
			toast.error("Failed to save question");
		}
	};

	//  Update Question
	const updateQuestion = async (question) => {
		const payload = {
			questionText: question.questionText,
			questionType: question.type.toUpperCase(),
			options: question.options.map((o) => ({
				optionText: o.optionText,
				score: o.score,
				flaggedHighRisk: o.flaggedHighRisk,
			})),
		};

		try {
			const updated = await Put(
				Url.riskTemplate.updateQuestionById(question.id),
				payload
			);
			setQuestions((prev) =>
				prev.map((q) => (q.id === updated.id ? updated : q))
			);
		} catch (err) {
			console.error(err);
			toast.error("Failed to update question");
		}
	};

	//  Delete Question
	const deleteQuestion = async (id) => {
		try {
			await Delete(Url.riskTemplate.deleteQuestionById(id));
			setQuestions((prev) => prev.filter((q) => q.id !== id));
		} catch (err) {
			console.error(err);
			toast.error("Failed to delete question");
		}
	};

	const openModal = (mode, question) => {
		setModalMode(mode);
		setSelectedQuestion(question);
		setModalOpen(true);
	};

	return (
		<div className={css.Page}>
			<div className={css.Main}>
				<div className={css.title}>
					<div
						style={{ cursor: "pointer" }}
						className="PHIcon"
						onClick={() => navigate("../")}
					>
						<Svg>{SvgOptions.ArrowBack}</Svg>
					</div>
					<h3>Add Risk Questions</h3>
				</div>

				<AddQuestionForm
					question={newQuestion}
					setQuestion={setNewQuestion}
					readOnly={false}
					questionTypes={questionTypes}
				/>

				<Button
					className={`${css.AddQuestionBtn} ${css.PrimaryBtn}`}
					onClick={() => createQuestion(newQuestion)}
				>
					Save Question
				</Button>
			</div>

			<div className={css.Aside}>
				<QuestionsAside questions={questions} onAction={openModal} />
			</div>

			{modalOpen && selectedQuestion && (
				<QuestionModal
					isOpen={modalOpen}
					onClose={() => setModalOpen(false)}
					mode={modalMode}
					question={selectedQuestion}
					updateQuestion={updateQuestion}
					deleteQuestion={deleteQuestion}
				/>
			)}
		</div>
	);
};

export default AddQuestion;
